import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  indexOf1xbs558u7wr52 as indexOf,
  trim11nh7r46at6sx as trim,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../okio-parent-okio/okio/Buffer.mjs';
import { Companion_instance6t1sbhsaq0u as Companion_instance } from '../../../../../okio-parent-okio/okio/Options.mjs';
import { Companion_getInstance2g1g1maz1t653 as Companion_getInstance } from '../../../../../okio-parent-okio/okio/ByteString.mjs';
import { DefaultApolloException8w3ielfxng0h as DefaultApolloException } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { bufferbiiev5vr4b6f as buffer } from '../../../../../okio-parent-okio/okio/Okio.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readHeaders($this, source) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var headers = ArrayList().p2();
  $l$loop: while (true) {
    var line = source.i3y();
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(line) === 0)
      break $l$loop;
    var index = indexOf(line, _Char___init__impl__6a9atx(58));
    // Inline function 'kotlin.check' call
    if (!!(index === -1)) {
      var message = 'Unexpected header: ' + line;
      throw IllegalStateException().o(toString(message));
    }
    // Inline function 'kotlin.text.trim' call
    var this_0 = substring(line, 0, index);
    var tmp = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    // Inline function 'kotlin.text.trim' call
    var this_1 = substring_0(line, index + 1 | 0);
    var tmp$ret$5 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new (HttpHeader())(tmp, tmp$ret$5);
    headers.i2(element);
  }
  return headers;
}
var PartSourceClass;
function PartSource() {
  if (PartSourceClass === VOID) {
    class $ {
      constructor($outer) {
        this.j66_1 = $outer;
      }
      l6() {
        if (equals(this.j66_1.r66_1, this)) {
          this.j66_1.r66_1 = null;
        }
      }
      v3y(sink, byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount < 0: ' + byteCount.toString();
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.check' call
        if (!equals(this.j66_1.r66_1, this)) {
          var message_0 = 'closed';
          throw IllegalStateException().o(toString(message_0));
        }
        var limit = currentPartBytesRemaining(this.j66_1, byteCount);
        return limit === 0n ? -1n : this.j66_1.k66_1.v3y(sink, limit);
      }
    }
    initMetadataForClass($, 'PartSource');
    PartSourceClass = $;
  }
  return PartSourceClass;
}
function currentPartBytesRemaining($this, maxResult) {
  $this.k66_1.t3x(fromInt($this.n66_1.q2()));
  var delimiterIndex = $this.k66_1.r3x().w3y($this.n66_1);
  var tmp;
  if (delimiterIndex === -1n) {
    var tmp0 = $this.k66_1.r3x().b3v_1;
    // Inline function 'kotlin.Long.minus' call
    var other = $this.n66_1.q2();
    // Inline function 'kotlin.Long.plus' call
    var this_0 = subtract(tmp0, fromInt(other));
    // Inline function 'kotlin.comparisons.minOf' call
    var b = add(this_0, fromInt(1));
    tmp = maxResult <= b ? maxResult : b;
  } else {
    // Inline function 'kotlin.comparisons.minOf' call
    tmp = maxResult <= delimiterIndex ? maxResult : delimiterIndex;
  }
  return tmp;
}
var PartClass;
function Part() {
  if (PartClass === VOID) {
    class $ {
      constructor(headers, body) {
        this.t66_1 = headers;
        this.u66_1 = body;
      }
      l6() {
        this.u66_1.l6();
      }
    }
    initMetadataForClass($, 'Part');
    PartClass = $;
  }
  return PartClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var MultipartReaderClass;
function MultipartReader() {
  if (MultipartReaderClass === VOID) {
    class $ {
      constructor(source, boundary) {
        this.k66_1 = source;
        this.l66_1 = boundary;
        this.m66_1 = (new (Buffer())()).r3y('--').r3y(this.l66_1).d3y();
        this.n66_1 = (new (Buffer())()).r3y('\r\n--').r3y(this.l66_1).d3y();
        this.o66_1 = 0;
        this.p66_1 = false;
        this.q66_1 = false;
        this.r66_1 = null;
        this.s66_1 = Companion_instance.i3v([Companion_getInstance().x3w('\r\n--' + this.l66_1 + '--'), Companion_getInstance().x3w('\r\n'), Companion_getInstance().x3w('--'), Companion_getInstance().x3w(' '), Companion_getInstance().x3w('\t')]);
      }
      v66() {
        // Inline function 'kotlin.check' call
        if (!!this.p66_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.q66_1)
          return null;
        if (this.o66_1 === 0 && this.k66_1.a3z(0n, this.m66_1)) {
          this.k66_1.c3v(fromInt(this.m66_1.q2()));
        } else {
          $l$loop: while (true) {
            var toSkip = currentPartBytesRemaining(this, 8192n);
            if (toSkip === 0n)
              break $l$loop;
            this.k66_1.c3v(toSkip);
          }
          this.k66_1.c3v(fromInt(this.n66_1.q2()));
        }
        var whitespace = false;
        afterBoundaryLoop: while (true) {
          switch (this.k66_1.l3y(this.s66_1)) {
            case 0:
              if (this.o66_1 === 0)
                throw DefaultApolloException().q44('expected at least 1 part');
              this.q66_1 = true;
              return null;
            case 1:
              this.o66_1 = this.o66_1 + 1 | 0;
              break afterBoundaryLoop;
            case 2:
              if (whitespace)
                throw DefaultApolloException().q44('unexpected characters after boundary');
              if (this.o66_1 === 0)
                throw DefaultApolloException().q44('expected at least 1 part');
              this.q66_1 = true;
              return null;
            case 3:
            case 4:
              whitespace = true;
              continue afterBoundaryLoop;
            case -1:
              if (this.k66_1.s3x()) {
                throw DefaultApolloException().q44('premature end of multipart body');
              } else {
                throw DefaultApolloException().q44('unexpected characters after boundary');
              }

          }
        }
        var headers = readHeaders(Companion_instance_0, this.k66_1);
        var partSource = new (PartSource())(this);
        this.r66_1 = partSource;
        return new (Part())(headers, buffer(partSource));
      }
      l6() {
        if (this.p66_1)
          return Unit_instance;
        this.p66_1 = true;
        this.r66_1 = null;
        this.k66_1.l6();
      }
    }
    initMetadataForClass($, 'MultipartReader');
    MultipartReaderClass = $;
  }
  return MultipartReaderClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  MultipartReader as MultipartReader25md2ukkr9jti,
};
//endregion

//# sourceMappingURL=MultipartReader.mjs.map
